import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Row from "./Row";
import Icon from "../../../components/Icon";

const Table = ({ 
  className, 
  items = [],
  onFolderSelect,
  currentFilter,
  onSelectionChange
}) => {
  const [chooseAll, setChooseAll] = useState(false);
  const [activeId, setActiveId] = useState(items[0]?.id || null);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (items.length > 0) {
      if (!activeId || !items.find(item => item.id === activeId)) {
        setActiveId(items[0]?.id || null);
      }
    } else {
      setActiveId(null);
    }
    setSelectedIds([]);
    setChooseAll(false);
  }, [items, activeId]);

  useEffect(() => {
    onSelectionChange?.(selectedIds);
  }, [selectedIds, onSelectionChange]);

  const handleSelect = (id) => {
    setSelectedIds(prev => {
      const newSelected = prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id];
      setChooseAll(newSelected.length === items.length && items.length > 0);
      return newSelected;
    });
  };

  const handleSelectAll = () => {
    const newChooseAll = !chooseAll;
    setChooseAll(newChooseAll);
    setSelectedIds(newChooseAll ? items.map(folder => folder.id) : []);
  };

  const handleFolderClick = (id) => {
    if (onFolderSelect) {
      onFolderSelect(id);
    }
  };

  // Fonction pour obtenir l'icône d'état en fonction de la progression et du filtre actuel
  const getProgressionIcon = (folder) => {
    if (!folder.progression) {
      return { name: "info", color: "#B5E4CA" };
    }

    const { progression } = folder;
    
    // Vérifier l'état en fonction du filtre actuel
    switch (currentFilter) {
      case 'pending_school':
        return !progression.ecole.valide ? 
          { name: "clock", color: "#FFBC99" } : 
          { name: "check", color: "#B5E4CA" };
      
      case 'pending_company':
        return !progression.entreprise.valide ? 
          { name: "clock", color: "#B1E5FC" } : 
          { name: "check", color: "#B5E4CA" };
      
      case 'pending_student':
        return !progression.etudiant.valide ? 
          { name: "clock", color: "#CABDFF" } : 
          { name: "check", color: "#B5E4CA" };
      
      case 'pending_opco':
        return !progression.entreprise.opco_assigne ? 
          { name: "clock", color: "#FFD88D" } : 
          { name: "check", color: "#B5E4CA" };
      
      case 'blocked':
        return (!progression.ecole.valide && !progression.entreprise.valide && !progression.etudiant.valide) ? 
          { name: "close", color: "#FF6A55" } : 
          { name: "check", color: "#B5E4CA" };
      
      default:
        // Pour le filtre 'all', afficher un statut global
        if (progression.ecole.valide && progression.entreprise.valide && progression.etudiant.valide) {
          return { name: "check", color: "#B5E4CA" }; // Tout est validé
        } else if (!progression.ecole.valide && !progression.entreprise.valide && !progression.etudiant.valide) {
          return { name: "close", color: "#FF6A55" }; // Rien n'est validé
        } else {
          return { name: "clock", color: "#FFBC99" }; // En cours
        }
    }
  };


  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={chooseAll}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Etudiant</div>
          <div className={styles.col}>Promotion</div>
          <div className={styles.col}>Entreprise</div>
          <div className={styles.col}>Opco</div>
        </div>
        
        {items.length > 0 ? (
          items.map((folder, index) => (
            <Row
              item={folder}
              key={folder.id}
              activeId={activeId}
              setActiveId={setActiveId}
              selected={selectedIds.includes(folder.id)}
              onSelect={handleSelect}
              onClick={() => handleFolderClick(folder.id)}
              progressionIcon={getProgressionIcon(folder)}
            />
          ))
        ) : (
          <div className={styles.empty}>Aucun dossier trouvé</div>
        )}
      </div>
    </div>
  );
};

export default Table;
